export const isNonProd = ['qa', 'dev'].includes(process.env.REACT_APP_ENV);
export const isProd = ['stage', 'prod'].includes(process.env.REACT_APP_ENV);
export const isDev = ['dev'].includes(process.env.REACT_APP_ENV);
export default { isNonProd, isProd, isDev };
